import { RecentActivity, ACTIVITY_TYPE_ICONS, ALERT_SEVERITY_COLORS } from '../../types/operational';

interface RecentActivityListProps {
  activities: RecentActivity[];
}

export function RecentActivityList({ activities }: RecentActivityListProps) {
  const formatTime = (timestamp: string) => {
    const date = new Date(timestamp);
    const now = new Date();
    const diffMs = now.getTime() - date.getTime();
    const diffMins = Math.floor(diffMs / 60000);
    
    if (diffMins < 1) return 'À l\'instant';
    if (diffMins < 60) return `Il y a ${diffMins} min`;
    const diffHours = Math.floor(diffMins / 60);
    if (diffHours < 24) return `Il y a ${diffHours}h`;
    const diffDays = Math.floor(diffHours / 24);
    return `Il y a ${diffDays}j`;
  };

  const getSeverityColor = (severity?: string) => {
    if (!severity) return 'text-gray-600';
    return severity === 'high' || severity === 'critical' ? 'text-red-600' : 
           severity === 'medium' ? 'text-yellow-600' : 'text-green-600';
  };

  return (
    <div className="bg-white rounded-lg shadow-md p-6">
      <h3 className="text-lg font-semibold text-gray-900 mb-4">Activité Récente</h3>
      <div className="space-y-4">
        {activities.length === 0 ? (
          <p className="text-gray-500 text-center py-4">Aucune activité récente</p>
        ) : (
          activities.map((activity) => (
            <div key={activity.id} className="flex items-start space-x-3 p-3 hover:bg-gray-50 rounded-lg transition-colors">
              <div className="flex-shrink-0 w-8 h-8 bg-gray-100 rounded-full flex items-center justify-center text-sm">
                {ACTIVITY_TYPE_ICONS[activity.type]}
              </div>
              <div className="flex-1 min-w-0">
                <p className={`text-sm font-medium ${getSeverityColor(activity.severity)}`}>
                  {activity.description}
                </p>
                <p className="text-xs text-gray-500 mt-1">
                  {activity.hotelName} • {formatTime(activity.timestamp)}
                </p>
              </div>
              {activity.severity && (
                <div className={`flex-shrink-0 w-2 h-2 rounded-full`} 
                     style={{ backgroundColor: ALERT_SEVERITY_COLORS[activity.severity] }}>
                </div>
              )}
            </div>
          ))
        )}
      </div>
    </div>
  );
}
